module.exports = __webpack_public_path__ + "img/UMW.dba5eaff.png";